import { Alert } from '@mui/material';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';

import AdGroupForm from '../components/AdGroups/AdGroupForm';
import AdGroupSkeleton from '../components/AdGroups/AdGroupSkeleton';
import useAdGroup from '../hooks/useAdGroup';
import useContract from '../hooks/useContract';

function AdGroupPage() {
  const params = useParams();
  const contract = useContract(Number(params.id));
  const adGroup = useAdGroup(Number(params.adGroupId));
  const location = useLocation();
  const activeTab = location.hash.substring(1);

  if (adGroup.isLoading || contract.isLoading) {
    return <AdGroupSkeleton />;
  }

  if (adGroup.isError) {
    return <Alert severity="error">Failed to load Ad Group</Alert>;
  }

  return <AdGroupForm adGroup={adGroup.data} contract={contract.data} activeTab={activeTab} refetch={adGroup.refetch} />;
}

export default AdGroupPage;
